import React, { useState, useEffect } from 'react';
import { Heading, Box, useBreakpointValue, Link } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import Slideshow from '@components/molecules/Slideshow';
import patternPurple from '@assets/pattern-purple.svg';
import { SwiperSlide } from 'swiper/react';
import ProductCardBodySlider from '@components/molecules/ProductCardBodySlider';
import FocusContentLink from '@components/molecules/FocusContentLink';
import { dataLayerClick } from '@helpers/dataLayerPush';
import { useSeoMeta } from '../../hooks/useSeoMeta';

const ProductCardRow = ({ data = null }) => {
  const { groups, focusContentLink = null } = data;

  const isDesktop = useBreakpointValue({ base: false, md: true });
  const [slidesPerView, setSlidesPerView] = useState(1);
  const [useNarrow] = useState(groups.length < 3);

  const {
    site: {
      siteMetadata: { language }
    }
  } = useSeoMeta();

  useEffect(() => {
    setSlidesPerView(isDesktop ? 3 : 2);
  }, [isDesktop, slidesPerView]);

  return (
    <Box
      bgImage={patternPurple}
      bgRepeat="repeat"
      overflow="hidden"
      pb={{ base: `14`, md: `16` }}
      className="related-products-wrapper"
      mb={{ base: `14`, md: `16` }}>
      <Wrapper narrow={useNarrow}>
        {groups.map((group) => {
          return (
            <Box key={group.id}>
              <Heading
                as="h2"
                color="purple.600"
                fontWeight="900"
                fontSize={{ base: `4xl`, md: `5xl` }}
                mt={{ base: `2.5rem`, md: `3.938rem` }}
                textTransform="uppercase">
                {group.title}
              </Heading>
              <Box
                pt="4"
                as="p"
                fontWeight="900"
                color="purple.600"
                fontSize={{ base: `md`, md: `2xl` }}>
                {group.description}
              </Box>
              <Slideshow
                pt="4"
                slidesPerView={slidesPerView}
                className="related-products">
                {group.products.map((item, i) => (
                  <SwiperSlide key={`slides${i + 1}`}>
                    <Link
                      href={`/products/${item.slug}`}
                      hrefLang={language.toLowerCase()}
                      _hover={{
                        textDecoration: `none`
                      }}
                      onClick={() => {
                        dataLayerClick({
                          event: `cta_click`,
                          clickText: `Card Wrapper`,
                          clickUrl: item.slug
                        });
                      }}>
                      <ProductCardBodySlider productData={item} isClickable />
                    </Link>
                  </SwiperSlide>
                ))}
              </Slideshow>
            </Box>
          );
        })}
      </Wrapper>
      {focusContentLink && (
        <FocusContentLink mb="0" mt="10" data={focusContentLink} />
      )}
    </Box>
  );
};

export default ProductCardRow;
